import { createdApi } from "~/services/api";

const api = createdApi(process.env.REACT_APP_URL_API_ENGAGEMENT);

const CONTROLLER_NAME = "/panel_event";

export const postEvent = (data) => {
  return api.post(`${CONTROLLER_NAME}/`, data);
}

export default {
  postEvent,
};
